<template>
  <router-view v-slot="{ Component }">
    <transition name="fade-slide-up" mode="out-in">
      <component :is="Component" />
    </transition>
  </router-view>
</template>

<style lang="scss">
@import '@/assets/styles/global.scss';
</style>
